import React, { useState, useEffect, useContext } from 'react';
import '../App.css';
import axios from 'axios';
import Sidebar from '../componenteExtra/SidebarAdmin';
import { GrupoContext } from '../GrupoContext';
import Modal from 'react-modal';
import { Toaster, toast } from 'react-hot-toast';
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement('#root');

const Lideres = () => {
    const { grupo, setGrupo } = useContext(GrupoContext);
    const [liderList, setLiderList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedLider, setSelectedLider] = useState(null);
    const [nuevoGrupo, setNuevoGrupo] = useState("");
    const [nuevoNombreLider, setNuevoNombreLider] = useState("");
    const [nuevoNombreSubrogante, setNuevoNombreSubrogante] = useState("");
    const [nuevaCantidadStaff, setNuevaCantidadStaff] = useState("");
    const [modalTipo, setModalTipo] = useState("");
    const [mostrarModal, setMostrarModal] = useState(false);
    const [modalAgregarLiderAbierto, setModalAgregarLiderAbierto] = useState(false);
    const [nuevoLider, setNuevoLider] = useState({
        numero_grupo: '',
        nombre_lider: '',
        nombre_subrogante: '',
        cantidad_staff: ''
    });


    const token = localStorage.getItem("access_token");

    useEffect(() => {
        const savedGrupo = localStorage.getItem('grupo');
        if (savedGrupo) setGrupo(savedGrupo);

        axios.get(`${process.env.REACT_APP_BACKEND_URL}/update_all_activity_counts`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(() => fetchLideres())
            .catch(error => console.error('Error al actualizar conteos: ', error));
    }, [setGrupo]);

    const fetchLideres = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_all_lideres2`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(res => setLiderList(res.data))
            .catch(error => console.error('Error fetching data: ', error));
    };

    const abrirModalModificar = (lider) => {
        setSelectedLider(lider);
        setNuevoGrupo(lider.numero_grupo);
        setNuevoNombreLider(lider.nombre_lider);
        setNuevoNombreSubrogante(lider.nombre_subrogante);
        setNuevaCantidadStaff(lider.cantidad_staff);
        setModalTipo("modificar");
        setMostrarModal(true);
    };

    const abrirModalDesactivar = (lider) => {
        setSelectedLider(lider);
        setModalTipo("desactivar");
        setMostrarModal(true);
    };

    const cerrarModal = () => {
        setMostrarModal(false);
        setSelectedLider(null);
        setNuevoGrupo("");
        setNuevoNombreLider("");
        setNuevoNombreSubrogante("");
        setNuevaCantidadStaff("");
    };

    const abrirModalAgregarLider = () => {
        setNuevoLider({
            numero_grupo: '',
            nombre_lider: '',
            nombre_subrogante: '',
            cantidad_staff: ''
        });
        setModalAgregarLiderAbierto(true);
    };

    const cerrarModalAgregarLider = () => {
        setModalAgregarLiderAbierto(false);
    };

    const handleInputNuevoLider = (e) => {
        const { name, value } = e.target;
        setNuevoLider(prev => ({ ...prev, [name]: value }));
    };

    const handleAgregarLider = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/agregar_lider_subrogante`, {
                numero_grupo: parseInt(nuevoLider.numero_grupo),
                nombre_lider: nuevoLider.nombre_lider,
                nombre_subrogante: nuevoLider.nombre_subrogante,
                cantidad_staff: parseInt(nuevoLider.cantidad_staff)
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Líder agregado con éxito");
            cerrarModalAgregarLider();
            fetchLideres();
        } catch (err) {
            console.error("Error al agregar líder:", err);
            toast.error("Error al agregar líder");
        }
    };

    const confirmarAccion = async () => {
        try {
            if (modalTipo === "modificar") {
                await axios.put(`${process.env.REACT_APP_BACKEND_URL}/modificar_lider_subrogante`, {
                    id_lider: selectedLider.id_lider,
                    numero_grupo: parseInt(nuevoGrupo),
                    nombre_lider: nuevoNombreLider,
                    nombre_subrogante: nuevoNombreSubrogante,
                    cantidad_staff: parseInt(nuevaCantidadStaff),
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                toast.success("Líder modificado con éxito");
            } else if (modalTipo === "desactivar") {
                await axios.put(`${process.env.REACT_APP_BACKEND_URL}/desactivar_lider_subrogante`, {
                    id_lider: selectedLider.id_lider,
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                toast.success("Líder desactivado");
            }
            cerrarModal();
            fetchLideres();
        } catch (err) {
            console.error("Error en la acción:", err);
            toast.error("Hubo un error");
        }
    };

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>líderes GET</h1>
                    <div className="filter-section">
                        <label htmlFor="searchTerm">Buscar por nombre del Líder: </label>
                        <input
                            type="text"
                            id="searchTerm"
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                        />
                        <div className="button-container">
                            <button onClick={abrirModalAgregarLider} className="add-user-btn">➕ Agregar Líder</button>
                        </div>
                    </div>
                    <div className="activities-table-container">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>Estado</th>
                                    <th>Número de Grupo</th>
                                    <th>Nombre del Líder</th>
                                    <th>Nombre Subrogante</th>
                                    <th>Cantidad de staff por grupo</th>
                                    <th>Actividades en espera</th>
                                    <th>Actividades sin asignar</th>
                                    <th>Actividades asignadas</th>
                                    <th>En espera de aprobación</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {liderList
                                    .filter(l => l.nombre_lider?.toLowerCase().includes(searchTerm.toLowerCase()))
                                    .map((lider, index) => (
                                        <tr key={index}>
                                            <td>
                                                <span className={lider.estado === 'activo' ? 'estado-activo' : 'estado-inactivo'}>
                                                    {lider.estado}
                                                </span>
                                            </td>
                                            <td>{lider.numero_grupo}</td>
                                            <td>{lider.nombre_lider}</td>
                                            <td>{lider.nombre_subrogante}</td>
                                            <td>{lider.cantidad_staff}</td>
                                            <td>{lider.actividades_sin_documentar}</td>
                                            <td>{lider.actividades_sin_asignar}</td>
                                            <td>{lider.actividades_asignadas}</td>
                                            <td>{lider.espera_aprobacion}</td>
                                            <td>
                                                <button onClick={() => abrirModalModificar(lider)} className="edit-button">✏️Modificar</button>
                                                <button onClick={() => abrirModalDesactivar(lider)} className="delete-button">🚫Desactivar</button>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Modal isOpen={mostrarModal} onRequestClose={cerrarModal} className="modal-content" overlayClassName="modal-overlay">
                <h2>{modalTipo === "modificar" ? "Modificar Datos del Líder" : "Desactivar Líder"}</h2>
                {modalTipo === "modificar" && (
                    <>
                        <label>Número de grupo:</label>
                        <input
                            type="number"
                            value={nuevoGrupo}
                            onChange={(e) => setNuevoGrupo(e.target.value)}
                        />
                        <label>Nombre del líder:</label>
                        <input
                            type="text"
                            value={nuevoNombreLider}
                            onChange={(e) => setNuevoNombreLider(e.target.value)}
                        />
                        <label>Nombre subrogante:</label>
                        <input
                            type="text"
                            value={nuevoNombreSubrogante}
                            onChange={(e) => setNuevoNombreSubrogante(e.target.value)}
                        />
                        <label>Cantidad de staff:</label>
                        <input
                            type="number"
                            value={nuevaCantidadStaff}
                            onChange={(e) => setNuevaCantidadStaff(e.target.value)}
                        />
                    </>
                )}
                <button onClick={confirmarAccion} className="deactivate-button">
                    {modalTipo === "modificar" ? "Confirmar modificación" : "Sí, desactivar"}
                </button>
                <button onClick={cerrarModal} className="back-button">Atrás</button>
            </Modal>
            <Modal
                isOpen={modalAgregarLiderAbierto}
                onRequestClose={cerrarModalAgregarLider}
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <h2>Añadir Nuevo Líder</h2>
                <label>Número de grupo:</label>
                <input
                    type="number"
                    name="numero_grupo"
                    placeholder="Número de grupo"
                    value={nuevoLider.numero_grupo}
                    onChange={handleInputNuevoLider}
                />
                <label>Nombre del líder:</label>
                <input
                    type="text"
                    name="nombre_lider"
                    placeholder="Nombre del líder"
                    value={nuevoLider.nombre_lider}
                    onChange={handleInputNuevoLider}
                />
                <label>Nombre del subrogante:</label>
                <input
                    type="text"
                    name="nombre_subrogante"
                    placeholder="Nombre del subrogante"
                    value={nuevoLider.nombre_subrogante}
                    onChange={handleInputNuevoLider}
                />
                <label>Cantidad de staff:</label>
                <input
                    type="number"
                    name="cantidad_staff"
                    placeholder="Cantidad de staff"
                    value={nuevoLider.cantidad_staff}
                    onChange={handleInputNuevoLider}
                />
                <button onClick={handleAgregarLider} className="submit-button">Confirmar</button>
                <button onClick={cerrarModalAgregarLider} className="close-button">Cerrar</button>
            </Modal>
            <Toaster />
        </div>
    );
};

export default Lideres;
